// @flow

import React, { Component } from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps';
import InfoWindowContent from './MapInfoWindow';
import type { GoogleMapProps as Props } from './map.types';

type State = {
  selectedMarker: number,
};

declare var google;

class MapWithAMarker extends Component<Props, State> {
  static defaultProps = {
    shops: [],
    showAllMarkup: false,
  };

  state = {
    selectedMarker: -1,
  };

  /**
   * Ensure that the map view updates when a new set of markers are applied
   * @param {Object} props
   */
  componentWillReceiveProps = ({ shops }) => {
    if (shops.length !== this.props.shops.length) {
      this.handleMapLoad(this.mapElement, shops);
    }
  };

  mapElement = null;

  /**
   * Function to toggle the visibility of Address Info Window
   * @param {number} key
   */
  onToggleOpen = key => {
    const selectedMarker = this.state.selectedMarker === key ? -1 : key;
    this.setState({ selectedMarker });
  };

  setMapRef = element => {
    this.mapElement = element;
    this.handleMapLoad(element);
  };

  /**
   *  Function to fit map markers so that all markers are visible.
   * @param {Object} map
   * @param {Array} shopsArray
   */
  handleMapLoad = (map, shopsArray) => {
    const { showAllMarkup } = this.props;
    const shops = shopsArray || this.props.shops;
    if (showAllMarkup) {
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < shops.length; i++) {
        const marker = new google.maps.Marker({
          position: { lat: shops[i].location.lat, lng: shops[i].location.lon },
          setMap: map,
        });
        bounds.extend(marker.getPosition());
      }

      /**
       * If there is only one marker the map is zoomed in too far so we offset the center of
       * the bounds set by the US shop marker. This will fix the zoomed in view.
       */
      if (shops.length === 1) {
        const offset = 0.002;
        const center = bounds.getCenter();
        bounds.extend(
          new google.maps.LatLng(center.lat() + offset, center.lng() + offset)
        );
        bounds.extend(
          new google.maps.LatLng(center.lat() - offset, center.lng() - offset)
        );
      }
      if (map) map.fitBounds(bounds);
    }
  };

  /**
   * Renders
   * @return {*}
   */
  render() {
    const { shops, zoom } = this.props;
    const { selectedMarker } = this.state;
    const myLocationMarker = {
      defaultOptions: {
        optimized: false,
      },
    };
    return (
      <GoogleMap
        defaultZoom={zoom}
        defaultCenter={{
          lat: Number(
            shops && shops[0] && shops[0].location && shops[0].location.lat
          ),
          lng: Number(
            shops && shops[0] && shops[0].location && shops[0].location.lon
          ),
        }}
        ref={this.setMapRef}
      >
        {shops.map((shop, index) => (
          <Marker
            key={shop.label}
            position={{
              lat: Number(shop.location.lat),
              lng: Number(shop.location.lon),
            }}
            {...myLocationMarker}
            title={shop.label}
            onClick={() => this.onToggleOpen(index)}
          >
            {selectedMarker === index && (
              <InfoWindow onCloseClick={this.onToggleOpen}>
                <InfoWindowContent
                  address={shop.address}
                  url={shop.url}
                  label={shop.label}
                />
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    );
  }
}

export default withScriptjs(withGoogleMap(MapWithAMarker));
